const BASE_URL = `https://api.mapbox.com/search/geocode/v6`;

export const FORWARD_URL = `${BASE_URL}/forward`;
export const REVERSE_URL = `${BASE_URL}/reverse`;
export const BATCH_URL = `${BASE_URL}/batch`;
